module.exports = __webpack_public_path__ + "images/role-fan.f7b61975d0137fadb896cf3e5d01c513.png";